<template>
  <teleport to="body">
    <div class="modal-overlay">
      <div class="modal-content">
        <header>
          <h4>{{ t('modal_call_received_title') }}</h4>
        </header>
        <main>
          <h4 class="call-info">
            <h4 class="semibold">{{ callIncoming?.title }}</h4>
            {{ t('alert_interpretation_request_received') }}
          </h4>
          <div class="actions">
            <button class="btn btn-outline-primary" @click="callHold">
              <p class="medium">{{ t('button_hold') }}</p>
            </button>
            <button class="btn btn-primary" @click="callReceive">
              <PhoneIcon class="icon-phone" />
              {{ t('button_answer_call') }}
            </button>
          </div>
        </main>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { holdConsultationCall } from '@/api/apiService';
import PhoneIcon from '@/components/icons/IconPhone.vue';
import { IResponseConsultationRecent } from '@/types/response';


const router = useRouter();

const { t } = useI18n();

const { callIncoming } = defineProps<{
  callIncoming: IResponseConsultationRecent;
}>();

const emit = defineEmits<{ close: []; hold: [] }>();

// 통화 보류
const callHold = async () => {
  await holdConsultationCall(callIncoming.chatId);
  emit('hold');
};

// 통화 받기
const callReceive = () => {
  const { code, chatId } = callIncoming;
  const newUrl = router.resolve({
    name: 'chat-entrance',
    params: { code },
  }).href;
  window.open(newUrl, '_blank');
  emit('close');
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
}

.modal-content {
  width: 21.375rem;
  background: white;
  border-radius: 8px;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem 0.75rem 1.25rem;
  border-bottom: 1px solid var(--color-gray-40);
}

.close-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 1.25rem;
  gap: 1rem;
}

.call-info {
  display: flex;
  align-self: flex-start;
}

.actions {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 3rem;
  gap: 0.5rem;
}

.icon-phone {
  width: 1.5rem;
  height: 1.5rem;
  fill: var(--color-white);
}

.btn {
  width: 49%;
}

.btn-outline-primary:hover {
  background-color: var(--color-navy-15);
}

.btn-primary:hover {
  background-color: var(--color-navy-200);
  box-shadow: 0 0 0 2px var(--color-navy-200) inset;
}

@media (min-width: 768px) {
  .modal-content {
    width: 25rem;
  }
}
</style>
